import React from 'react';
import Header from '../components/Header';
import ContactInfo from '../components/homeComponents/ContactInfo';
import ProductsInfo from '../components/homeComponents/ProductsInfo';
import CalltoActionSection from '../components/homeComponents/CalltoActionSection';
import Footer from '../components/Footer';
import Landing from './Landing';
import CookieConsent from 'react-cookie-consent';
import { useEffect } from 'react';
import { getSection } from '../service/UserService';
import { useState } from 'react';
import Section from './Section';

const HomeScreen = () => {
  const [section, setSection] = useState();
  // const [error, setError] = useState();

  useEffect(() => {
    getSection().then((res) => setSection(res[0]));
    // .catch((error) => setError(error.response.data.message));
  }, []);

  return (
    <div>
      <Header searcherDisabled={true} shopLink={true} />
      <Landing />
      {section && <Section section={section} />}
      <ProductsInfo />
      <ContactInfo />
      <CalltoActionSection />
      <Footer />
      <CookieConsent
        location='bottom'
        buttonText='Aceptar todas las cookies'
        enableDeclineButton
        declineButtonText='Rechazar todas las cookies'
        cookieName='deportes-sporting'
        style={{ background: '#2B373B' }}
        buttonStyle={{ color: '#4e503b', fontSize: '13px' }}
        declineButtonStyle={{ fontSize: '13px' }}
        expires={150}
      >
        Al hacer clic en “Aceptar todas las cookies”, usted acepta que las
        cookies se guarden en su dispositivo para mejorar la navegación del
        sitio web.
      </CookieConsent>
    </div>
  );
};

export default HomeScreen;
